import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddProjectLayer from "../../components/Projects/AddProjectLayer";




const AddProjectPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  title="Add Project" />

        {/* Add Project Layer */}
        <AddProjectLayer />

      </MasterLayout>
    </>
  );
};

export default AddProjectPage;
